import { render, staticRenderFns } from "./myBtn.vue?vue&type=template&id=54999afc&scoped=true&"
import script from "./myBtn.vue?vue&type=script&lang=js&"
export * from "./myBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54999afc",
  null
  
)

export default component.exports